module.exports = __webpack_public_path__ + "static/media/info.06740054.svg";